import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../service/server.service';
import {LoadingController} from '@ionic/angular';

@Component({
  selector: 'app-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {

  text: any;

  constructor(private activatedRoute: ActivatedRoute, public server: ServerService, public loadingController: LoadingController) {


  }

  data: any;
  fakeData = [1, 2, 3, 4, 5, 6, 7];

  ngOnInit() {
    this.loadData();
  }

  async loadData() {


  };

}
